import type { OrgType } from "@/lib/auth/resolve-org-type";

import type { FeatureTab } from "../types";
import { DEMO_TABS } from "./demo-tabs";

export interface DemoUrlState {
  readonly tab: FeatureTab;
  readonly orgMode: OrgType;
}

const DEFAULT_STATE: DemoUrlState = { tab: "painel", orgMode: "creator" };

/**
 * Os parâmetros de `/demo` viram estado da demo. Valor que não existe cai no
 * padrão em vez de deixar o palco vazio: a URL vem de link colado, de anúncio
 * e de histórico antigo, e nada disso é confiável.
 */
export function resolveDemoUrlState({
  tela,
  conta,
}: {
  tela?: string | null;
  conta?: string | null;
}): DemoUrlState {
  const orgMode: OrgType = conta === "collab" ? "collab" : "creator";
  const tab = DEMO_TABS.find((candidate) => candidate.id === tela);

  if (!tab || (tab.collabOnly && orgMode !== "collab")) {
    return { tab: DEFAULT_STATE.tab, orgMode };
  }

  return { tab: tab.id, orgMode };
}
